module.exports = "<div id=\"manage-inventory\" class=\"section-full-height section-scrollable\">\n  <div class=\"new-page-content\">\n    <div class=\"loading-wrapper\" ng-if=\"loading\">\n      <page-loader loading=\"loading\"></page-loader>\n    </div>\n    <inventory-list ng-if=\"!loading\" venue=\"venue\" is-enabled=\"isEnabled\" type=\"currentSection\" date=\"currentDateUTC\"></inventory-list>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/manageInventory/manageInventory.html
// module id = 1162
// module chunks = 0